export const arrayToQueryParams = (
  name: string,
  values: (string | number | boolean)[]
) => {
  const encodedName = encodeURIComponent(name);

  return `${encodedName}[]=${values
    .map(encodeURIComponent)
    .join(`&${encodedName}[]=`)}`;
};
